var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoKry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 144,
    viewBox: "0 0 256 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3763 105.808L59.0909 55.4229L73.6343 41.463C77.9354 37.3339 81.7204 35.2049 88.7741 34.0005V32.0005H55.3978V34.0005C63.8279 35.721 65.5483 39.7426 59.8709 45.248L32 71.9701V0H30.1075L0 10.0002V12.0002C1.03226 12.5163 4 14.7959 4 20.4735V105.98C4 110.797 2.58064 114.109 0 116.002V118.002H36V116.002C33.4193 114.109 32 110.797 32 105.98V81.4266L39.1304 74.5824L54.3655 109.765C55.2257 111.658 56.172 114.561 55.9999 118.002H89.9784V115.959C85.5053 113.206 84.301 112.518 81.3763 105.808Z",
    fill: "#1B4349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.194 32V34C239.14 35.7205 241.548 40.0861 237.935 48.3443L221.408 85.6346L204.215 46.7959C201.462 40.2582 202.495 35.7205 207.484 34V32H166V34C169.613 35.7205 172.215 39.57 173.936 43.5271L207.133 118.222C203.918 124.814 200.727 128.002 196.473 128.002C188.215 128.002 185.979 115.958 174.796 115.958C167.742 115.958 162.065 120.604 162.065 127.829C162.065 135.916 169.29 144.002 181.505 144.002C192.516 144.002 205.763 137.292 213.333 120.431L247.398 44.2152C250.151 38.1937 253.075 34.6882 256 34V32H230.194Z",
    fill: "#1B4349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.161 29.9373C138.839 29.9373 132.301 37.8513 128 50.0666V30.0018H126L96 40.0019V42.0665C97.0323 42.5826 99.957 44.9052 99.957 50.5827V105.981C99.957 110.799 98.5806 114.068 96 115.96V118.003H132.989V115.96C129.72 114.068 128 110.799 128 105.981V68.1314C128 55.4 132.473 48.0021 137.634 48.0021C143.828 48.0021 146.064 58.1528 152.602 58.1528C157.591 58.1528 163.957 52.3032 163.957 43.873C163.957 35.9589 158.279 29.9373 149.161 29.9373Z",
    fill: "#1B4349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKry);
export default __webpack_public_path__ + "static/media/logo-kry.6d88645e109a22b874677686a6d9083f.svg";
export { ForwardRef as ReactComponent };